// Client-side view of the patient session (magic-link JWT).
//
// Only used to decide what to SHOW — the server still verifies every request.
// A token that has expired is treated as absent, because the server treats it
// as anonymous and an enforcing org would reject every call it makes.

export const PATIENT_TOKEN_REQUIRED_EVENT = 'patient-token-required'

export function isPatientSessionUsable(token: string | null | undefined, now: number = Date.now()): boolean {
  if (!token) return false
  const payload = token.split('.')[1]
  if (!payload) return false
  try {
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
    // No exp claim → let the server decide
    return typeof json.exp !== 'number' || json.exp * 1000 > now
  } catch {
    return false
  }
}
